import React, { useEffect, useState } from "react";
import { useIntl } from 'react-intl';

// Components
import { Form, Pill } from 'Components';
import { Grid } from '@mui/material';
import Slider from 'Components/Slider';
import TagsManage from 'Modules/.common/components/TagsManage';

export const Landmark = (props) => {

    const { value, triggers, triggersRaw, onChange, formRef } = props
    const { messages } = useIntl()
    const [localLoading, setLocalLoading] = useState(true)

    // <---- Entity Selector Setup ---->
    const entities = [
        { id: "Landmark", label: messages['alertsNewAlert_Landmark_name'] || "Landmark" },
        { id: "All", label: messages['alertsNewAlert_Landmark_all'] || "All" },
    ];

    useEffect(() => {
        if (!triggersRaw) {
            let entities = triggers?.map(x => { return x.entity })
            let newValues = value
            if (!value.triggerDuration)
                newValues = {
                    "triggerDuration": {
                        "value": 0,
                        "duration": "Immediate"
                    },
                    "trigger": "Enter",
                    "recurring": {
                        "value": 0,
                        "frequency": "OnlyOnce"
                    }
                }
            onChange(newValues, entities)
            setLocalLoading(false)
        }
    }, [triggersRaw]);
    const durationLabel = {
        Minutes: messages['alertsNewAlert_minutes'],
        Hours: messages['alertsNewAlert_hours'],
        Days: messages['alertsNewAlert_days'],
    }

    if (localLoading) return

    //The data we're sending to this step is a combination of tags and landmarks, so we need to filter and map it accordingly. Landmarks didn't have parentId before, it's being added now based on the matching tag.
    const getFilteredValue = () => {
        if (!triggersRaw || triggersRaw.length === 0) return [];

        // Check if "All" is selected
        const hasAllSelected = triggersRaw.some(item => item.id === "-1" && item?.name === 'All');

        if (hasAllSelected) {
            return [{ id: "-1", name: "All" }];
        }

        // Get tags and landmarks from triggersRaw
        const tags = triggersRaw.filter(item => item.name === "Tag");
        const landmarks = triggersRaw.filter(item => item.name === "Landmark");

        // Transform landmarks to include parentId
        return landmarks.map(landmark => {
            const matchingTag = tags.find(tag => tag.label === landmark.label);

            return {
                name: landmark.name,
                id: parseInt(landmark.id),
                label: landmark.label,
                parentId: matchingTag ? parseInt(matchingTag.id) : null
            };
        });
    };

    return (
        <Form ref={formRef}
            onSubmit={() => {
                return triggersRaw?.length > 0;
            }}
        >
            <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 10 }}>
                <div style={{ width: "100%" }}>
                    {
                        (!triggersRaw || triggersRaw?.length == 0) &&
                        <div className="text-danger" style={{ paddingBottom: 10 }}>
                            {messages["alertsNewAlert_landmarkValidation"]}
                        </div>
                    }
                    <TagsManage
                        entities={entities}
                        value={getFilteredValue()}
                        entitySelected={entities.find(x => x.id == (triggersRaw?.find(x => x.id == "-1" && x?.name == 'All') && "All" || "Landmark"))}
                        setEntitySelected={(newSelectedEntity) => {

                            if (newSelectedEntity?.id === "All") {
                                onChange(value, [{ id: "-1", name: "All" }]);
                            } else {
                                onChange(value, []);
                            }
                        }}
                        onChange={(selectedItems, entity) => {
                            onChange(value,
                                selectedItems.map(selectedItem => {
                                    return { ...selectedItem, label: entity.id }
                                })
                            )
                        }}
                        height={240}
                        mode="list"
                        onlyTags={false}
                    />
                </div>

                <Grid item >
                    <div style={{ paddingBottom: 5 }}>
                        <label className="input-normal-label" >{messages['alertsNewAlert_triggersLabel']}</label>
                    </div>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                        <Grid item sm={4}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Enter", name: messages["alertsNewAlert_enter"] }}
                                outlined={value.trigger !== "Enter"}
                                onClick={(entity) => {
                                    onChange({ ...value, trigger: "Enter" })
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={4}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Exit", name: messages["alertsNewAlert_exit"] }}
                                outlined={value.trigger !== "Exit"}
                                onClick={(entity) => {
                                    onChange({ ...value, trigger: "Exit" })
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={4}>
                            <Pill
                                textField={'name'}
                                item={{ id: "All", name: messages["alertsNewAlert_both"] }}
                                outlined={value.trigger !== "All"}
                                onClick={(entity) => {
                                    onChange({ ...value, trigger: "All" })
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item style={{ paddingTop: 20 }}>
                    <div style={{ paddingBottom: 5 }}>
                        <label className="input-normal-label" >{messages['alertsNewAlert_insideDuration']}</label>
                    </div>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Immediate", name: messages["alertsNewAlert_immediate"] }}
                                outlined={value.triggerDuration?.duration !== "Immediate"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, triggerDuration: { value: 0, duration: 'Immediate' }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Minutes", name: messages["alertsNewAlert_minutes"] }}
                                outlined={value.triggerDuration?.duration !== "Minutes"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, triggerDuration: { value: 1, duration: 'Minutes' }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Hours", name: messages["alertsNewAlert_hours"] }}
                                outlined={value.triggerDuration?.duration !== "Hours"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, triggerDuration: { value: 1, duration: 'Hours' }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Days", name: messages["alertsNewAlert_days"] }}
                                outlined={value.triggerDuration?.duration !== "Days"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, triggerDuration: { value: 1, duration: 'Days' }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                    </Grid>

                    {
                        value.triggerDuration?.duration && value.triggerDuration?.duration != "Immediate" &&
                        <div style={{ width: '100%', marginTop: 10 }}>
                            <label className="input-normal-label">
                                {value.triggerDuration?.duration == "Minutes" && messages['alertsNewAlert_minutes']}
                                {value.triggerDuration?.duration == "Hours" && messages['alertsNewAlert_hours']}
                                {value.triggerDuration?.duration == "Days" && messages['alertsNewAlert_days']}
                            </label>
                            <Slider
                                value={value.triggerDuration?.value}
                                onChange={(event) => onChange(
                                    {
                                        ...value,
                                        triggerDuration: { ...value.triggerDuration, value: event },
                                    }, triggersRaw
                                )}
                                min={1}
                                max={
                                    value.triggerDuration?.duration == "Minutes" && 59 ||
                                    value.triggerDuration?.duration == "Hours" && 23 ||
                                    value.triggerDuration?.duration == "Days" && 30 || 0
                                }
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                                disabled={!value.triggerDuration.duration}
                            />
                        </div>
                    }
                </Grid>

                <Grid item style={{ paddingTop: 20 }}>
                    <div style={{ paddingBottom: 5 }}>
                        <label className="input-normal-label" >{messages['alertsNewAlert_recurring']}</label>
                    </div>
                    <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "OnlyOnce", name: messages["alertsNewAlert_onlyOnce"] }}
                                outlined={value.recurring?.frequency !== "OnlyOnce"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, recurring: { value: null, frequency: "OnlyOnce" }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Minutes", name: messages["alertsNewAlert_minutes"] }}
                                outlined={value.recurring?.frequency !== "Minutes"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, recurring: { value: 1, frequency: "Minutes" }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Hours", name: messages["alertsNewAlert_hours"] }}
                                outlined={value.recurring?.frequency !== "Hours"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, recurring: { value: 1, frequency: "Hours" }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                        <Grid item sm={3}>
                            <Pill
                                textField={'name'}
                                item={{ id: "Days", name: messages["alertsNewAlert_days"] }}
                                outlined={value.recurring?.frequency !== "Days"}
                                onClick={(entity) => {
                                    onChange({
                                        ...value, recurring: { value: 1, frequency: "Days" }
                                    }, triggersRaw);
                                }}
                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                label="pill-label-text"
                                colorField="default"
                                colorSelection="005bf8"
                            />
                        </Grid>
                    </Grid>

                    {
                        value.recurring?.frequency && value.recurring?.frequency != "OnlyOnce" &&
                        <div style={{ width: '100%', marginTop: 10 }} >
                            <label className="input-normal-label">
                                {value.recurring?.frequency == "Minutes" && messages['alertsNewAlert_minutes']}
                                {value.recurring?.frequency == "Hours" && messages['alertsNewAlert_hours']}
                                {value.recurring?.frequency == "Days" && messages['alertsNewAlert_days']}
                            </label>
                            <Slider
                                value={value.recurring?.value}
                                onChange={(event) => onChange({ ...value, recurring: { ...value.recurring, value: event } }, triggersRaw)}
                                min={1}
                                max={
                                    value.recurring?.frequency == "Minutes" && 59 ||
                                    value.recurring?.frequency == "Hours" && 23 ||
                                    value.recurring?.frequency == "Days" && 30 || 0
                                }
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                                disabled={!value.recurring?.frequency}
                            />
                        </div>
                    }
                </Grid>


            </Grid>
        </Form >
    );
}

